import { axios } from '@/utils/http'
import { Config } from '@/models/config'

export async function fetchConfigs(): Promise<Config[]> {
  const { data } = await axios.get(`Configs`)
  return data
}

export async function fetchConfig(key: string): Promise<Config> {
  const { data } = await axios.get(`Configs/${key}`)
  return data
}

export async function putConfig(config: Config): Promise<Config> {
  const { data } = await axios.put(`Configs/${config.key}`, config)
  return data
}
